// Module
var code = `<!-- clSteps — explicit numbered sequence where each step contains nested blocks.
     Data shape (from author):
         { items: [ { title: "markdown", blocks: [...cl* block objects...] }, ... ] }

     Pipeline normalizations per step:
         stepNumber      — 1-based index, injected by the pipeline
         title           — passed through (markdown-parsed)
         renderedBlocks  — array of HTML strings, one per original block.
                           Each inner block is rendered by its own template first,
                           then the rendered result is added to this array as a
                           string. The template below iterates that array.

     The array-of-strings shape lets each rendered block sit in its own
     .block-cl-steps__block wrapper — useful for per-block styling (spacing,
     alignment, step-scoped overrides) without needing to bake those concerns
     into every inner block's template. -->
<ol class="block-cl-steps">
  {{#items}}
  <li class="block-cl-steps__step">
    <div class="block-cl-steps__marker" aria-hidden="true">{{stepNumber}}</div>
    <div class="block-cl-steps__content">
      <div class="block-cl-steps__title">{{title}}</div>
      <div class="block-cl-steps__blocks">
        {{#renderedBlocks}}<div class="block-cl-steps__block">{{.}}</div>{{/renderedBlocks}}
      </div>
    </div>
  </li>
  {{/items}}
</ol>
`;
// Exports
module.exports = code;